import AppBarTools from '@/components/system/Layout/LayoutWebCore/WebCoreAppBar/ToolBar';
import TelegramMiniAppAutoLogin from '@/components/system/Auth/TelegramMiniAppAutoLogin';

import LocalizedLink from '@/components/ui/LocalizedLink';
import MoonLogo from '@/components/biz/MoonLogo';
import { ProfileBox } from '@/components/system/Layout/LayoutWebCore/WebCoreAppBar/styles';
import { isTelegramMiniAppView, isWoWSpaceView } from '@/utils/checkRuntime';
import RewardsDropdown from '../SideBarHeader/rewards';
import AuthModal from '@/components/system/Auth/AuthModal';
import dynamic from 'next/dynamic';
import React from 'react';
import { Box } from '@mui/material';
import LangSimpleSwitch from '@/components/system/LangSimpleSwitch';
export const RewardsSection = ({
  appSidebarOpen,
}: {
  appSidebarOpen?: boolean;
}) => {
  return (
    <Box
      sx={{
        height: '42px',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <RewardsDropdown />
    </Box>
  );
};
const WalletWidget = dynamic(
  () => import('@/components/features/wallet/WalletWidget'),
  {
    ssr: false,
  },
);

const WalletWidgetPlaceholder = dynamic(
  () => import('@/components/features/wallet/WalletWidgetPlaceholder'),
  {
    ssr: false,
  },
);

const renderWalletComponent = (
  isTemporaryLogin: boolean,
  loggedIn: boolean,
) => {
  if (isTemporaryLogin) {
    return <WalletWidgetPlaceholder />;
  }
  if (loggedIn) {
    return <WalletWidget />;
  }
  return null;
};

export const AppBarContent = ({ isMobile, loggedIn, isTemporaryLogin }) => (
  <AppBarTools>
    {isMobile ? (
      // 移动端使用两列布局：左侧Logo，右侧钱包
      <>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: '0 0 auto',
            justifyContent: 'flex-start',
          }}
        >
          <MoonLogo />
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: '1 1 auto',
            justifyContent: 'flex-end',
          }}
        >
          <Box sx={{mr: 2}}>
            {loggedIn && renderWalletComponent(isTemporaryLogin, loggedIn)}
          </Box>
          <AuthModal />
        </Box>
      </>
    ) : (
      // 桌面端保持三列布局
      <>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: '1 1 0',
            justifyContent: 'flex-start',
          }}
        >
          <MoonLogo />
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: '1 1 0',
            justifyContent: 'center',
          }}
        >
          {renderWalletComponent(isTemporaryLogin, loggedIn)}
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: '1 1 0',
            justifyContent: 'flex-end',
          }}
        >
          <ProfileBox
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <LangSimpleSwitch iconSize="29px" />
            {isTelegramMiniAppView ? (
              <TelegramMiniAppAutoLogin />
            ) : (
                <AuthModal />
            )}
          </ProfileBox>
        </Box>
      </>
    )}
  </AppBarTools>
);
